<ng-container *ngIf="!isNewLocation; else new">
  <div class="visitors-container">
    <img class="visitors-icon" alt="logo-eye" src="assets/global/img/visitors-icon.svg" />
    <span class="visitors-numer">{{visitorsNumber}} </span>
    <span *ngIf="open" class="visitors-text">
      <span class="visitors-text-title"> {{'users' | translate}} </span>
      {{'activeNow' | translate}}
    </span>
    <button class="visitors-button" (click)="open = !open">
      <span *ngIf="open; else hideDetails">
        <ion-icon name="eye-off-outline" class="visitors-button__icon"></ion-icon>
      </span>
      <ng-template #hideDetails>
        <ion-icon name="eye-outline" class="visitors-button__icon"></ion-icon>
      </ng-template>
    </button>
  </div>
</ng-container>
<ng-template #new>
  <div class="newVisitors">
    <img class="newVisitors__img" alt="logo-user" [src]="lobbyConstants.imgUser" />
    <span class="newVisitors__txt"
      ><span>{{visitorsNumber}}</span> {{'users' | translate}} <br *ngIf="globalVars?.user?.playingSlots" />
      {{'activeNowShort' | translate}}</span
    >
  </div>
</ng-template>
